"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteBlog } from "@/lib/actions/blogs/delete/deleteBlog";

const serverDeleteBlog = async (id: string) => {
  const response = await deleteBlog(id);
  return response;
};

export const useDeleteBlog = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: serverDeleteBlog,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["blogs"] });
    },
  });
};
